import { UserBasketSettingsLocationFragment, Address } from '@/generated/graphql'
import { SPLITS, useFeatureFlag } from '@/helpers/useFeatureFlag'
import useTenant from '@/hooks/useTenant'
import { basketLocationToAddress } from '@caterdesk/utils--gm-validation'
import { getCountryFromLocale } from '@fusion/locale/parsing'

import { compact } from 'lodash'
import { useParams } from 'next/navigation'

type AddressParts = Partial<
  Pick<Address, 'flatOrBuilding' | 'floorOrBuildingName' | 'street' | 'city' | 'postcode'>
>

export const formatFullAddress = (address: AddressParts) =>
  compact([
    address.flatOrBuilding,
    address.floorOrBuildingName,
    address.street,
    address.city,
    address.postcode,
  ]).join(', ')

export const useAddressLabel = (address?: UserBasketSettingsLocationFragment | Address) => {
  const params = useParams()
  const tenant = useTenant()
  const enabledFullAdressLabel = useFeatureFlag(SPLITS.GM_SHOW_FULL_ADDRESS)
  const country = getCountryFromLocale((params?.lang as string) || tenant.defaultLocale)
  const basketLocationObject = address ? basketLocationToAddress(address) : undefined

  let addressLabel = basketLocationObject
    ? basketLocationObject.postcode || basketLocationObject.street
    : undefined
  const showFullAddress =
    enabledFullAdressLabel &&
    basketLocationObject &&
    tenant.features?.gmShowFullAddress?.visibility?.regions.includes(country.toUpperCase())
  if (showFullAddress) {
    addressLabel = formatFullAddress(basketLocationObject)
  }
  return { addressLabel, showFullAddress }
}
